import { jsxs as o, jsx as l } from "react/jsx-runtime";
const c = (r) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...r,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m49.601 16.363-.793-.63-.802-.637-.986.279-5.423 1.534-.501.142-.368.368-1.511 1.511a2.78 2.78 0 0 0-.793 2.362l-4.36 4.356a6.288 6.288 0 0 0-.491-.79c-1.129-1.543-2.846-2.427-4.71-2.427-1.112 0-2.785.32-4.45 1.848-1.067.98-1.988 2.34-2.735 4.045-.426.972-.616 1.294-.7 1.39-.111.084-.55.318-2.255.778a15.75 15.75 0 0 0-5.168 2.518c-2.147 1.597-3.596 3.616-4.19 5.84-.697 2.612-.55 6.705 4.114 11.368 3.06 3.06 6.166 4.61 9.235 4.61a8.826 8.826 0 0 0 4.3-1.112c1.113-.612 2.133-1.468 3.033-2.544 1.737-2.077 2.66-4.507 3.129-6.18.165-.589.27-1.102.354-1.515.04-.198.093-.454.132-.606.117-.095.403-.3 1.007-.604 1.082-.545 1.96-1.252 2.608-2.099.9-1.175 1.309-2.588 1.154-3.98-.098-.874-.542-2.633-2.456-3.998 2.984-2.989 5.648-5.655 6.902-6.904a2.681 2.681 0 0 0 1.805-.802l5.096-5.148 1.57-1.586-1.747-1.387Zm-6.342 6.716a.7.7 0 0 1-.997.003c-.035.005-12.656 12.658-15.118 15.127l1.392 1.419.021-.004 4.506-4.517c2.064.981 1.711 2.628-.194 3.588-3.382 1.704-2.895 2.897-3.545 5.218-.922 3.292-3.129 6.916-6.61 6.916-1.797 0-3.933-.965-6.407-3.439-7.407-7.407-.358-12.006 3.458-13.036 3.817-1.03 4.36-1.649 5.576-4.424 1.117-2.546 2.448-3.499 3.521-3.499 1.132 0 1.978 1.06 1.987 2.43l-6.503 6.496 1.4 1.428 15.095-15.08-.226-.252a.795.795 0 0 1 .016-1.109l1.51-1.51 5.423-1.535.793.63-5.098 5.15Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m20.247 38.465-1.414 1.414 4.883 4.883 1.415-1.414-4.884-4.883Z"
        }
      )
    ]
  }
);
export {
  c as GuitarMusic
};
